module.exports = __webpack_public_path__ + "img/pro_two_10.7c4f6855.jpg";